module.exports = __webpack_public_path__ + "img/hexagon-minus.a8ee7f9d.svg";